// extracted by mini-css-extract-plugin
export default {"box":"PageBox_box__V1PmK"};